import React, { useEffect, useRef, useState } from 'react';
import Wishlist from './Wishlist';
import { translate } from '../Services/translation';
import WishlistOverview from './WishlistOverview';
import Notification from './Notification';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAllWishlists,
    updateWishlistName,
    addToCart,
    addAllToCart,
    deleteWishlistItem,
    showWishlistDrawer,
    setActiveWishlist,
    setIsInWishlist,
    addSharedWishlist,
    getWishlist,
    setIncludedInWishlists,
    getWishlistSummary,
} from '../Actions/Wishlist.action';
import ShareWishlistContainer from './ShareWishlistContainer';

const WishlistContainer = () => {
    const wishlist = useSelector((state) => state.wishlist);
    const includedInWishlists = useSelector(
        (state) => state.wishlist.includedInWishlists
    );
    const activeListName = useSelector((state) => state.wishlist.active);
    const showInfo = useSelector((state) => state.wishlist.show);
    const { payload } = wishlist;
    const ref = useRef(null);
    const [showError, setShowError] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllWishlists());
        if (activeListName) {
            dispatch(getWishlist(activeListName));
        }
    }, [activeListName, dispatch]);

    useEffect(() => {
        setShowError(false);
        const handleSharedWishlist = () => {
            const queryParams = new URLSearchParams(window.location.search);
            const wishlistId = queryParams.get('wishlistId');
            if (!wishlistId) return;
            else {
                try {
                    const result = dispatch(addSharedWishlist(wishlistId));
                    dispatch(setActiveWishlist(result.wishlistName));
                    dispatch(getAllWishlists());
                } catch (error) {
                    setShowError(true);
                    dispatch(showWishlistDrawer(false));
                }
                dispatch(showWishlistDrawer(true));
            }
        };

        handleSharedWishlist();
        dispatch(getAllWishlists());
        dispatch(getWishlistSummary());
    }, [dispatch, includedInWishlists]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                ref.current &&
                !ref.current.contains(event.target) &&
                showInfo == true
            ) {
                onToggle();
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, showInfo]);

    const handleAddAllToCart = (listName) => {
        dispatch(addAllToCart(listName));
    };

    const handleAddToCart = (articleNumber, quantity) => {
        dispatch(addToCart(articleNumber, quantity));
    };

    const resetWishlistState = () => {
        dispatch(setActiveWishlist(''));
    };

    const updateActiveList = (listName) => {
        dispatch(setActiveWishlist(listName));
    };

    const handleRemoveItem = async (sortIndex, articleId) => {
        const list = wishlist.lists.find((x) => x.name === activeListName);
        const product = wishlist.list.find((x) => x.listId === list.id);
        await dispatch(deleteWishlistItem(sortIndex, activeListName)).then(
            () => {
                const updatedIncludedInWishlists = includedInWishlists?.filter(
                    (item) => item !== activeListName
                );
                if (
                    product.articleNumber === articleId &&
                    updatedIncludedInWishlists?.length === 0
                ) {
                    dispatch(setIsInWishlist(false, activeListName));
                    dispatch(getWishlist(activeListName));
                }
                dispatch(getWishlist(activeListName));
                dispatch(setIncludedInWishlists(updatedIncludedInWishlists));
                dispatch(getWishlistSummary());
            }
        );
    };

    const handleUpdateWishlistName = async (previousName, newName) => {
        dispatch(updateWishlistName(previousName, newName)).then(() =>
            dispatch(getAllWishlists())
        );
        resetWishlistState();
    };

    const onToggle = () => {
        dispatch(showWishlistDrawer(!showInfo));
        resetWishlistState();
    };

    return (
        <div className="wishlist">
            <a
                className="wishlist__link--block"
                rel="nofollow"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onToggle();
                }}
            >
                <i className="wishlist__icon">
                    <span className="wishlist__quantity">
                        {wishlist.summary.totalItemCount}
                    </span>
                </i>
            </a>
            <div
                className={`wishlist__info 
                ${
                    !showInfo
                        ? 'wishlist__info--hidden'
                        : 'wishlist__info--visible'
                }`}
            >
                <div className="wishlist__content-wrapper" ref={ref}>
                    <div className="wishlist__content-top">
                        {activeListName == '' ? (
                            <p className="wishlist__title">
                                {translate('wishlist.title')}
                            </p>
                        ) : (
                            <a
                                className="wishlist__title wishlist__title--link"
                                onClick={() => {
                                    resetWishlistState();
                                }}
                            >
                                <p>{activeListName}</p>
                            </a>
                        )}

                        <span
                            className="wishlist__close-button"
                            onClick={() => onToggle()}
                        ></span>
                    </div>
                    {payload && payload.addToCart && (
                        <Notification text={payload.addToCart.message} info />
                    )}
                    {showError && (
                        <Notification
                            text={translate('wishlist.sharednotfound')}
                        />
                    )}
                    {payload && payload.addAllToCart && (
                        <Notification
                            text={payload.addAllToCart.message}
                            info
                        />
                    )}
                    {payload && payload.success == false && (
                        <Notification text={payload.message} />
                    )}
                    {!activeListName || !wishlist.list ? (
                        <WishlistOverview
                            edit={activeListName !== ''}
                            onUpdateActiveList={(listName) =>
                                updateActiveList(listName)
                            }
                            onUpdateWishlistName={(previousName, newName) => {
                                handleUpdateWishlistName(previousName, newName);
                            }}
                        />
                    ) : (
                        <>
                            <Wishlist
                                list={wishlist.list}
                                onRemoveItem={(sortIndex, articleId) => {
                                    handleRemoveItem(sortIndex, articleId);
                                }}
                                onAddToCart={handleAddToCart}
                            />

                            <div className="wishlist__sum">
                                <ShareWishlistContainer
                                    activeList={activeListName}
                                />
                                <button
                                    className="button wishlist__add-to-cart-button"
                                    onClick={() => {
                                        handleAddAllToCart(activeListName);
                                    }}
                                >
                                    {translate('wishlist.addalltocart')}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WishlistContainer;
